// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type QuestionMark20CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const QuestionMark20Circle: FC<QuestionMark20CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path
                d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm-.781-11.74c-.202.494-.302 1.24-.302 2.24h2.229c.014-.792.087-1.344.219-1.656.131-.313.482-.733 1.052-1.26.666-.626 1.128-1.178 1.385-1.657.257-.48.386-1.01.386-1.594 0-1.125-.39-2.045-1.167-2.76C14.243 4.858 13.236 4.5 12 4.5a4.33 4.33 0 0 0-2.594.833 4.234 4.234 0 0 0-1.594 2.209l2 .833c.167-.556.445-.993.834-1.313.389-.319.84-.479 1.354-.479.583 0 1.063.17 1.438.51.374.341.562.775.562 1.303 0 .389-.104.74-.313 1.052-.208.312-.61.726-1.208 1.24-.639.555-1.059 1.08-1.26 1.572Zm-.281 6.303c.291.291.645.437 1.062.437.417 0 .77-.146 1.063-.438.291-.291.437-.645.437-1.062 0-.417-.146-.77-.438-1.063A1.446 1.446 0 0 0 12 16c-.417 0-.77.146-1.063.438A1.446 1.446 0 0 0 10.5 17.5c0 .417.146.77.438 1.063Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default QuestionMark20Circle;
